<div
  [class]="'sm-card ' + convertColors()"
  [class.metric]="isMetric"
  style="margin-bottom: 15px"
  [style.border-left-color]="customColor ? customColor : ''"
>
  <div *ngIf="!isMetric" class="header">
    <div class="info" [class.header-wrapper]="allowCollapse || iconSecondary" (dblclick)="onDoubleClick()">
      <h3 *ngIf="title">
        <span class="title-wrapper">
          <span *ngIf="icon">
            <i *ngIf="isFontAwesomeIcon(icon)" [class]="icon"></i>
            <aurora-icon *ngIf="!isFontAwesomeIcon(icon)" [icon]="auroraIconName(icon)"></aurora-icon>
          </span>
          <span>{{ title }}</span>
          <aurora-badge *ngIf="count" type="count" prominence="low" [color]="statusBadgeColor">{{ count }}</aurora-badge>
        </span>
        <aurora-icon
          *ngIf="iconSecondary"
          [icon]="auroraIconName(iconSecondary)"
          style="margin-left: 0.25rem"
          [ngbTooltip]="iconSecondaryTooltip"
        ></aurora-icon>
        <aurora-icon-button
          *ngIf="allowCollapse"
          [icon]="collapsed ? 'chevron-down' : 'chevron-up'"
          (click)="onDoubleClick()"
          [ngbTooltip]="collapsed ? 'Expand Section' : 'Collapse Section'"
        ></aurora-icon-button>
      </h3>

      <div *ngIf="desc" class="description">{{ desc }}</div>
    </div>
  </div>
  <div class="body">
    <ng-container *ngIf="isMetric; else other_content">
      <div *ngIf="icon" class="icon magenta">
        <aurora-icon *ngIf="!isFontAwesomeIcon(icon); else otherIcon" [icon]="auroraIconName(icon)"></aurora-icon>
        <ng-template #otherIcon>
          <i class="fa {{ icon }}" style="color: var(--aurora-semantic-foreground-neutral-tertiary); font-size: 3rem"></i>
        </ng-template>
      </div>
      <div class="info">
        <div *ngIf="label" class="label">
          {{ label }}
        </div>
        <h3 *ngIf="stat" class="stat">{{ stat }}</h3>
        <div class="description">
          {{ desc || subtitle || '&nbsp;' }}
          <div
            *ngIf="progress"
            class="ep-progressbar-frame"
            style="height: 5px; width: 100%; margin-top: 2px; background-color: #cdcaca"
          >
            <div class="ep-progressbar" [style.width.%]="progress" style="height: 100%"></div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #other_content><ng-content></ng-content></ng-template>
  </div>
</div>
